import { ReactElement, useCallback } from 'react';

import { DayOfWeek, TimeOfDay } from '@dreryk/egabinet-waitlist-frontend-api';

import { BindingCreator } from '@dreryk/react-common';

import { translationKeys } from '../../../translations';
import { WaitlistFormController } from '../../WaitlistForm.types';
import { TIMES_OF_DAY } from '../DayPreferenceField/DayPreferenceField.constants';

import { StyledAllDaysPreferencesField } from './AllDaysPreferencesField.styled';
import { DAYS_OF_WEEK } from './AllDaysPreferencesField.constants';

type AllDaysPreferencesFieldFormBeanPart = {
   allDaysPreferences: boolean;
};

type AllDaysPreferencesFieldProps = {
   register: BindingCreator<AllDaysPreferencesFieldFormBeanPart>;
   sync: WaitlistFormController['sync'];
};

export const AllDaysPreferencesField = (props: AllDaysPreferencesFieldProps): ReactElement => {
   const { sync } = props;
   const handleChange = useCallback(
      (selected: boolean) => {
         const dayTimePreferences = DAYS_OF_WEEK.reduce(
            (acc, day) => ({
               ...acc,
               [day]: selected ? TIMES_OF_DAY : ([] as TimeOfDay[]),
            }),
            {} as Record<DayOfWeek, TimeOfDay[]>
         );
         sync({
            dayTimePreferences: dayTimePreferences,
            dayTimePreferencesValidation: !selected,
         });
      },
      [sync]
   );
   return (
      <StyledAllDaysPreferencesField
         testId={'allDaysPreferences'}
         label={translationKeys.allDays}
         controller={props.register('allDaysPreferences')}
         onSelectionChange={handleChange}
      />
   );
};
